(() => {
  if (customElements.get('lh-cart-stylist')) return;
  let adding = false;
  class CartStylist extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.dataset.ready = '';
      this.addEventListener('change', event => {
        const choice = event.target.closest('[data-lh-variant]');
        if (!choice) return;
        const card = choice.closest('.lh-stylist__card');
        const button = card.querySelector('[data-lh-add]');
        button.disabled = !choice.value || adding;
        const option = choice.selectedOptions?.[0];
        if (option?.dataset.price) card.querySelector('.lh-stylist__price').textContent = option.dataset.price;
      }, { signal: this.abort.signal });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-lh-add]');
        if (!button || button.disabled || adding) return;
        event.preventDefault();
        this.addItem(button);
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
    async addItem(button) {
      const card = button.closest('.lh-stylist__card');
      const variant = card.querySelector('[data-lh-variant]').value;
      if (!variant || adding) return;
      adding = true;
      const status = this.querySelector('[role="status"]');
      const originalLabel = button.textContent;
      const root = window.Shopify?.routes?.root || '/';
      const checkoutButtons = [...document.querySelectorAll('button[name="checkout"]')].filter(item => !item.disabled);
      const offerButtons = [...document.querySelectorAll('[data-lh-add]')];
      const activeButtons = offerButtons.filter(item => !item.disabled);
      activeButtons.forEach(item => { item.disabled = true; });
      checkoutButtons.forEach(item => { item.disabled = true; });
      button.setAttribute('aria-busy', 'true');
      button.textContent = this.dataset.adding;
      status.textContent = '';
      let posted = false;
      let rejected = false;
      let accepted = false;
      let unavailable = false;
      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
        const sectionIds = [...new Set(sections)].slice(0, 5);
        posted = true;
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }], sections: sectionIds, sections_url: location.pathname }),
          signal: AbortSignal.timeout(15000)
        });
        const result = await response.json();
        if (!response.ok) {
          rejected = true;
          unavailable = response.status === 422;
          throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        }
        accepted = true;
        if (this.dataset.context === 'page') {
          location.reload();
          return;
        }
        const cartResponse = await fetch(root + 'cart.js', { signal: AbortSignal.timeout(10000) });
        if (!cartResponse.ok) throw new Error(this.dataset.uncertain);
        const cart = await cartResponse.json();
        if (sectionIds.some(id => !result.sections?.[id])) {
          location.assign(root + 'cart');
          return;
        }
        cart.sections = result.sections || {};
        const announce = document.getElementById('status-announcement');
        if (announce) announce.textContent = this.dataset.added;
        document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: result.items || [result], cart, onSuccessDo: 'force_open_drawer' } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart } }));
        status.textContent = this.dataset.added;
      } catch (error) {
        if (accepted || (posted && !rejected)) {
          status.textContent = this.dataset.uncertain;
          const link = document.createElement('a');
          link.href = root + 'cart';
          link.className = 'link';
          link.textContent = this.dataset.review;
          status.append(' ', link);
          button.dataset.uncertain = '';
        } else {
          status.textContent = error.message || this.dataset.error;
          if (unavailable) {
            const choice = card.querySelector('select');
            if (choice) {
              const option = choice.selectedOptions[0];
              if (option) option.disabled = true;
              choice.value = '';
            } else button.dataset.uncertain = '';
          }
        }
      } finally {
        adding = false;
        activeButtons.forEach(item => {
          const choice = item.closest('.lh-stylist__card')?.querySelector('[data-lh-variant]');
          item.disabled = item.hasAttribute('data-uncertain') || !choice?.value;
        });
        checkoutButtons.forEach(item => { item.disabled = false; });
        button.removeAttribute('aria-busy');
        button.textContent = originalLabel;
      }
    }
  }
  customElements.define('lh-cart-stylist', CartStylist);
})();
